import React, { useState, useContext } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import "./TopBar.css";
import logo from "../assets/logo.png";
import { LanguageContext } from "../context/LanguageContext";

const TopBar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isDashboard = location.pathname === "/dashboard";

  const { language, changeLanguage, texts } = useContext(LanguageContext);

  const [showContact, setShowContact] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const [message, setMessage] = useState("");
  const [sending, setSending] = useState(false);
  const [success, setSuccess] = useState(false);

  // -------------------------------------------------------
  // Kontaktformular
  // -------------------------------------------------------
  const closeContact = () => {
    setShowContact(false);
    setSuccess(false);
    setMessage("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);

    try {
      const token = localStorage.getItem("authToken");

      await fetch(`${process.env.REACT_APP_API_URL}/api/contact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ message }),
      });

      setSuccess(true);
      setMessage("");
    } catch (err) {
      console.error("Kontaktfehler:", err);
    } finally {
      setSending(false);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem("authToken");
    navigate("/login");
  };

  // -------------------------------------------------------
  // RENDER
  // -------------------------------------------------------
  return (
    <>
      <header className="topbar">
        <div className="topbar-left" onClick={() => navigate("/dashboard")}>
          <img src={logo} alt="Logo" className="topbar-logo" />
        </div>

        {/* Desktop Navigation */}
        <div className="topbar-right desktop-only">
          {!isDashboard && (
            <button className="topbar-back" onClick={() => navigate("/dashboard")}>
              {texts.menu.backToDashboard}
            </button>
          )}

          <button className="topbar-help" onClick={() => setShowContact(true)}>
            {texts.menu.help}
          </button>

          <select
            className="topbar-lang"
            value={language}
            onChange={(e) => changeLanguage(e.target.value)}
          >
            <option value="de">Deutsch</option>
            <option value="en">English</option>
            <option value="it">Italiano</option>
            <option value="fr">Français</option>
            <option value="nl">Nederlands</option>
            <option value="es">Español</option>
            <option value="hr">Hrvatski</option>
          </select>


          <button className="topbar-logout" onClick={handleLogout}>
            {texts.menu.logout}
          </button>
        </div>

        {/* Hamburger Icon */}
        <button
          className="hamburger mobile-only"
          onClick={() => setMobileMenuOpen(true)}
        >
          ☰
        </button>
      </header>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="mobile-menu-overlay" onClick={() => setMobileMenuOpen(false)}>
          <div className="mobile-menu" onClick={(e) => e.stopPropagation()}>

            {/* X Button */}
            <button className="mobile-close" onClick={() => setMobileMenuOpen(false)}>
              ×
            </button>

            <div className="mobile-scroll">
              <img src={logo} alt="Logo" className="mobile-menu-logo" />

              <nav className="mobile-nav">
                {!isDashboard && (
                  <button
                    className="mobile-nav-item"
                    onClick={() => {
                      navigate("/dashboard");
                      setMobileMenuOpen(false);
                    }}
                  >
                    {texts.menu.backToDashboard}
                  </button>
                )}

                <button
                  className="mobile-nav-item"
                  onClick={() => {
                    navigate("/object-list");
                    setMobileMenuOpen(false);
                  }}
                >
                  {texts.menu.myObjects}
                </button>

                <button
                  className="mobile-nav-item"
                  onClick={() => {
                    navigate("/settings");
                    setMobileMenuOpen(false);
                  }}
                >
                  {texts.menu.settings}
                </button>

                <button
                  className="mobile-nav-item"
                  onClick={() => {
                    setShowContact(true);
                    setMobileMenuOpen(false);
                  }}
                >
                  {texts.menu.help}
                </button>

                {/* Sprache – Menü bleibt offen */}
                <select
                  className="mobile-lang"
                  value={language}
                  onChange={(e) => changeLanguage(e.target.value)}
                >
                  <option value="de">Deutsch</option>
                  <option value="en">English</option>
                  <option value="it">Italiano</option>
                  <option value="fr">Français</option>
                  <option value="nl">Nederlands</option>
                  <option value="es">Español</option>
                  <option value="hr">Hrvatski</option>
                </select>
              </nav>
            </div>

            <button
              className="mobile-logout-btn"
              onClick={() => {
                handleLogout();
                setMobileMenuOpen(false);
              }}
            >
              {texts.menu.logout}
            </button>
          </div>
        </div>
      )}

      {/* Kontakt-Modal */}
      {showContact && (
        <div className="contact-overlay" onClick={closeContact}>
          <div className="contact-modal" onClick={(e) => e.stopPropagation()}>

            <button className="contact-x" onClick={closeContact}>×</button>

            <h2>{texts.contact.title}</h2>
            <p>{texts.contact.subtitle}</p>

            <form className="contact-form" onSubmit={handleSubmit}>
              <label className="contact-label">{texts.contact.messageLabel}</label>
              <textarea
                value={message}
                onChange={(e) => setMessage(e.target.value)}
                placeholder={texts.contact.messageLabel}
                required
              />

              <button type="submit" className="contact-submit" disabled={sending}>
                {sending ? "..." : texts.contact.send}
              </button>

              {success && (
                <p className="contact-success">{texts.contact.success}</p>
              )}
            </form>

            <button className="contact-close" onClick={closeContact}>
              {texts.contact.close}
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default TopBar;
